import type { ThemeName } from "@repo/tokens";
import { readThemeDebugFromSession } from "@repo/tokens";

/** Root ThemeProvider initial theme; respects session when theme debug was set (dev only). */
export function resolveInitialTheme(): ThemeName {
  if (import.meta.env.PROD) {
    return "learn";
  }
  return readThemeDebugFromSession() ?? "learn";
}
